import axios from 'axios';

const fetchResourceFilters = async ({ educationPeriod, url }) => {
  const response = await axios.get(`${FYM_UNITS_BACKEND_URL}/${url}`, {
    params: {
      minimal_fields_only: true,
      educationPeriod,
    },
  });
  return response.data;
};

export default fetchResourceFilters;
